import { ReactNode } from 'react';
import Progress from 'antd/lib/progress';
import { IoIosArrowForward, IoIosArrowBack } from 'react-icons/io';
import Button from '../button/Button';
import Text from '../text/Text';
import CloseActionButton from '../action-button/CloseActionButton';
import styles from './Step.module.css';

type StepProps = {
  showNext: boolean;
  showPrev: boolean;
  stepsCount: number;
  stepNum: number;
  progress: number;
  children: ReactNode;
  isNextEnabled: boolean;
  onStepChange: (stepNum: number) => void;
  onContinue: () => void;
  onClose: () => void;
};

const Step = ({
  showNext,
  showPrev,
  stepsCount,
  stepNum,
  progress,
  children,
  isNextEnabled,
  onStepChange,
  onClose,
  onContinue,
}: StepProps) => {
  const goNext = () => onStepChange(stepNum + 1);
  const goPrev = () => onStepChange(stepNum - 1);

  return (
    <div className={styles.wrapper}>
      <div className={styles.overlay}>
        <div className={styles.header}>
          <div>
            <CloseActionButton onClose={onClose} />
            <Text
              centered
              style={{ flex: '1', lineHeight: '46px', paddingRight: '48px' }}
            >
              {stepNum}/{stepsCount}
            </Text>
          </div>
          <Progress
            percent={progress}
            showInfo={false}
            strokeColor='var(--color-primary)'
          />
        </div>
        <div className={styles.body}>{children}</div>
        <div className={styles.footer}>
          {showPrev && (
            <Button
              type='transparent'
              width='content-width'
              style={{ float: 'left' }}
              onClick={goPrev}
            >
              <IoIosArrowBack />
            </Button>
          )}
          {showNext && (
            <Button
              type='primary'
              width='content-width'
              style={{ float: 'right' }}
              isReadOnly={!isNextEnabled}
              onClick={stepNum === stepsCount ? onContinue : goNext}
            >
              <IoIosArrowForward />
            </Button>
          )}
        </div>
      </div>
    </div>
  );
};

export default Step;
